import { render, staticRenderFns } from "./AbilityWatcher.vue?vue&type=template&id=073fa5b8&scoped=true&"
import script from "./AbilityWatcher.vue?vue&type=script&lang=js&"
export * from "./AbilityWatcher.vue?vue&type=script&lang=js&"
import style0 from "./AbilityWatcher.vue?vue&type=style&index=0&id=073fa5b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fa5b8",
  null
  
)

export default component.exports